import { Component } from '@angular/core';

@Component({
  selector: 'itl-page-wrapper',
  template: '<ng-content></ng-content>',
  styleUrls: ['./page-wrapper.component.scss'],
})
export class PageWrapperComponent {}
